import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { Observable, Observer } from 'rxjs/Rx';
import { FileObject, FileMediaData, MetaData, FileInclMetaData } from '../../models';
import { FileApi } from '../../services/webservice';
import { FileUpload, UploadEvent } from '../../services';
import { Spinner, ControlMessages } from "../../ui-helper"
import { Response } from '@angular/http';


@Component({
	selector: 'files',
	templateUrl: "./files.html",
	styles: [require("./files.scss")]
})
export class Files {
	@Input()
	public accept: string;
	@Input()
	public uploadLabel: string;
	@Input()
	public altTextRequired: string;
	@Input()
	public titleRequired: string;
	@Input()
	public sourceRequired: string;
	@Input()
	public titleLabel: string;

	@Input()
	public set fileMediaData(fileMediaData: FileMediaData[]) {
		if (!fileMediaData) return;
		this.loadFilesFromFileMediaData(fileMediaData);
	}
	@Output()
	public fileMediaDataChange: EventEmitter<FileMediaData[]> = new EventEmitter<FileMediaData[]>();
	public showSpinner = false;
	public percentLoaded = "0%";
	public fileObjectsAndMetaDataForm: { file: FileObject, form: FormGroup }[] = []

	constructor(public fileApi: FileApi, public formBuilder: FormBuilder) {
	}

	public addFileList(fileList: FileList) {
		for (let i = 0; i < fileList.length; i++) {
			this.addFile(fileList.item(i));
		}
	}

	public downloadFile(fileObject: FileObject) {
		this.fileApi.downloadFile(fileObject.metaData.fileStorageName, fileObject.metaData.fileName);
	}

	public addFile(file: File) {
		let fileObject = FileObject.fromFile(file);
		let metaDataForm = this.createMetaDataForm(fileObject)
		this.fileObjectsAndMetaDataForm.push({ file: fileObject, form: metaDataForm })
	}

	public delete(obj: { file: FileObject, form: FormGroup }) {
		let index = this.fileObjectsAndMetaDataForm.indexOf(obj);
		this.fileObjectsAndMetaDataForm.splice(index, 1)
	}


	public save() {
		if (this.fileObjectsAndMetaDataForm.length === 0) {
			this.pushMediaDataIfNoErrors([]);
			return
		}
		this.showSpinner = true;
		let fileUpload = new FileUpload(this.fileApi)
		let fileObjects = this.updateMetaData(this.fileObjectsAndMetaDataForm)
		fileUpload.saveFileObjects(fileObjects).subscribe(
			(uploadEvent: UploadEvent) => {
				if (uploadEvent.percentLoaded)
					this.percentLoaded = uploadEvent.percentLoaded + "%"
				if (uploadEvent.finished) {
					this.showSpinner = false;
					this.pushMediaDataIfNoErrors(uploadEvent.fileObjects);
				}
			}
		);
	}



	public areAllFormsValid(): boolean {
		if (this.fileObjectsAndMetaDataForm.length === 0) return true;
		return this.fileObjectsAndMetaDataForm
			.map(element => element.form.valid)
			.reduce((prev, current) => prev && current) //if one is false the whole get false
	}

	private loadFilesFromFileMediaData(fileMediaData: FileMediaData[]) {
		let metaDataIds = fileMediaData.map(fileMediaData => fileMediaData.fileMetaDataId)
		this.fileApi.getFileInclMetaDataList(metaDataIds).subscribe(
			(fileInclMetaData: FileInclMetaData[]) => {
				this.fileObjectsAndMetaDataForm = []
				for (let listElement of fileInclMetaData) {
					let fileObject = FileObject.fromFileInclMetaData(listElement)
					let metaDataForm = this.createMetaDataForm(fileObject)
					this.fileObjectsAndMetaDataForm.push({ file: fileObject, form: metaDataForm })
				}
			}
		)
	}

	private createMetaDataForm(fileObject: FileObject): FormGroup {
		let captionValidator = null;
		let altTextValidator = null;
		let sourceValidator = null;
		if (this.titleRequired === "true") {
			captionValidator = Validators.required
		}
		if (this.sourceRequired === "true") {
			sourceValidator = Validators.required
		}
		if (this.altTextRequired === "true") {
			altTextValidator = Validators.required
		}
		return this.formBuilder.group({
			'caption': new FormControl(fileObject.metaData.caption, captionValidator),
			'altText': new FormControl(fileObject.metaData.altText, altTextValidator),
			'source': new FormControl(fileObject.metaData.source, sourceValidator)
		});
	}

	private pushMediaDataIfNoErrors(fileObjects: FileObject[]) {
		let result = []
		for (let fileObject of fileObjects) {
			if (!fileObject.uploadSuccessful || fileObject.uploadError) {
				return
			}
			let fileMediaData = new FileMediaData();
			fileMediaData.fileMetaDataId = fileObject.metaData.id;
			result.push(fileMediaData);
		}
		this.fileMediaDataChange.emit(result)
	}

	private updateMetaData(list: { file: FileObject, form: FormGroup }[]): FileObject[] {
		let fileObjects = []
		for (let item of list) {
			item.file.metaData.caption = item.form.value["caption"]
			item.file.metaData.source = item.form.value["source"]
			item.file.metaData.altText = item.form.value["altText"]
			item.file.metaData.accessRight = "EVERYBODY"
			fileObjects.push(item.file);
		}
		return fileObjects;
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/files/files.component.ts